import './App.css';
import { Header } from './components/Header/Header';
import { Toaster } from 'react-hot-toast';
import { NavRoutes } from './routes/NavRoutes';
import { useData } from './contexts/DataProvider';
import { ScrollToTop } from './components/ScrollToTop/ScrollToTop';
import { Loader } from './components/Loader/Loader';
// import { Footer } from './components/Footer/Footer';

function App() {
	const { loading } = useData();

	return (
		<div className='App'>
			<Header />
			{loading && <Loader />}
			<NavRoutes />
			<ScrollToTop />
			<Toaster
				position='top-left'
				reverseOrder={false}
				toastOptions={{
					success: { duration: 2000 },
					error: { duration: 6000 },
				}}
				containerStyle={{
					top: '6rem',
				}}
			/>
			{/* <Footer /> */}
		</div>
	);
}

export default App;
